function toCurrencyString(amount, currency, decimalPlaces) {
	return amount.toLocaleString(undefined, {
		style: "currency",
		currency: currency,
		maximumFractionDigits: decimalPlaces,
	});
}

function minToHoursAndMins(mins) {
	var hours = (mins / 60).toFixed(0);
	var minutes = mins - hours * 60;
	if (minutes < 10) {
		minutes = "0" + minutes.toString();
	}
	var output = "";
	return output + hours + ":" + minutes;
}

function toShortDateString(date) {
	var parsedDate = new Date(date).toDateString();
	parsedDate = parsedDate.substr(parsedDate.indexOf(" ") + 1);
	return parsedDate;
}

function getInputDateFormat(date, isDateTimeLocal = false) {
	var _Date = new Date(date),
		Day = _Date.getDate() > 9 ? _Date.getDate() : "0" + _Date.getDate(),
		Month =
			_Date.getMonth() + 1 > 9
				? _Date.getMonth() + 1
				: "0" + (_Date.getMonth() + 1);
	if (!isDateTimeLocal) {
		return _Date.getFullYear() + "-" + Month + "-" + Day;
	} else {
		var Hours =
			_Date.getHours() > 9 ? _Date.getHours() : "0" + _Date.getHours();
		var Minutes =
			_Date.getMinutes() > 9 ? _Date.getMinutes() : "0" + _Date.getMinutes();
		return (
			_Date.getFullYear() +
			"-" +
			Month +
			"-" +
			Day +
			"T" +
			Hours +
			":" +
			Minutes
		);
	}

	// 2018-06-12T19:30
}

function parseDateToYMD(dateString) {
	const dateObj = new Date(dateString);
	const year = dateObj.getFullYear();
	const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
	const day = dateObj.getDate().toString().padStart(2, '0');
	return `${year}-${month}-${day}`;
  }
  // Example output: 2023-07-11"
  

function getTimeIn12Hours(date) {
	var Hours = new Date(date).getHours();
	var timeOfDay = parseInt(Hours) >= 12 ? "PM" : "AM";
	var Minutes = new Date(date).getMinutes();
	Hours = Hours <= 12 ? Hours : Hours - 12;
	return (
		Hours.toString().padStart(2, "0") +
		":" +
		Minutes.toString().padStart(2, "0") +
		" " +
		timeOfDay
	);
}

// Format: 09-Jul-25 14:45
function formatToDDMMMYY_HHmm(date) {
	if (!date) return "";

	const providedDate = new Date(date);
	const day = String(providedDate.getDate()).padStart(2, "0");
	const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
						"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	const month = monthNames[providedDate.getMonth()];
	const year = String(providedDate.getFullYear()).slice(-2);
	const hours = String(providedDate.getHours()).padStart(2, "0");
	const minutes = String(providedDate.getMinutes()).padStart(2, "0");

	return `${day}-${month}-${year} ${hours}:${minutes}`;
}

// Format: 09-Jul-25 14:45:09
function formatToDDMMMYY_HHmmss(date) {
	if (!date) return "";

	const providedDate = new Date(date);
	const seconds = String(providedDate.getSeconds()).padStart(2, "0");

	return `${formatToDDMMMYY_HHmm(date)}:${seconds}`;
}

function parseForURL(string) {
	return string?.replace(/[^a-zA-Z0-9.-]/gi, "");
}

module.exports = {
	toCurrencyString,
	toShortDateString,
	getInputDateFormat,
	parseDateToYMD,
	getTimeIn12Hours,
	minToHoursAndMins,
	parseForURL,
	formatToDDMMMYY_HHmm,
	formatToDDMMMYY_HHmmss
};
